/**
 * BLNC wordmark.
 *
 * The same mark the lonefox workspace uses, and for the same reason: it is
 * type in a square, so it stays crisp at any size and needs no asset. Square
 * corners are deliberate — the mark is the one sharp thing in a rounded
 * interface, which is what makes it read as a mark.
 *
 * Propene is a blnc product, so the house mark is the right one here. The
 * business's own name sits beside it in the rail.
 */
export function Wordmark({
  className = '',
  inverted = false,
}: {
  className?: string
  inverted?: boolean
}) {
  return (
    <span
      className={`wordmark ${inverted ? 'wordmark--inverted' : ''} ${className}`}
      aria-label="BLNC"
    >
      <span>BL</span>
      <span>
        NC<span className="wordmark__dot">.</span>
      </span>
    </span>
  )
}
